
export const permissions = [
    {
        module: 'users',
        actions: [
            { name: 'create', value: true },
            { name: 'read', value: true },
            { name: 'update', value: true },
            { name: 'delete', value: true },
        ],
    },
    {
        module: 'projects',
        actions: [
            { name: 'create', value: true },
            { name: 'read', value: true },
            { name: 'update', value: true },
            { name: 'delete', value: true },
        ],
    },
    {
        module: 'orders',
        actions: [
            { name: 'create', value: true },
            { name: 'read', value: true },
            { name: 'update', value: true },
            { name: 'delete', value: true },
        ],
    },
    {
        module: 'clients',
        actions: [
            { name: 'create', value: true },
            { name: 'read', value: true },
            { name: 'update', value: true },
            { name: 'delete', value: true },
        ],
    },
    {
        module: 'settings',
        actions: [
            { name: 'create', value: true },
            { name: 'read', value: true },
            { name: 'update', value: true },
            { name: 'delete', value: true },
        ],
    },
     {
        module: 'partners',
        actions: [
            { name: 'create', value: true },
            { name: 'read', value: true },
            { name: 'update', value: true },
            { name: 'delete', value: true },
        ],
    },
];